import { Eye, EyeOff, X } from "lucide-react";
import { useState, useEffect } from "react";

export const EmployeeEditForm = ({
  employee,
  onSave,
  onCancel,
  isReadOnly,
  accounts,
  loadingAccounts,
  selectedAccount,
  setAccountQuery,
  setSelectedAccount,
  setAccounts,
  accountQuery,
  onUpdatePassword,
}) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobileNumber: "",
    role: "CUSTOMER",
    password: "",
  });
  const [passData, setPassData] = useState({
    userId: employee?.id,
    newPassword: "",
  });

  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (employee) {
      setFormData({
        fullName: employee.fullName || "",
        email: employee.email || "",
        mobileNumber: employee.mobileNumber || "",
        role: employee.role || "CUSTOMER",
      });
    }
  }, [employee]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "fullName") {
      const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData({ ...formData, [name]: lettersOnly });
    } else if (name === "mobileNumber") {
      const numbersOnly = value.replace(/[^0-9]/g, "");
      if (numbersOnly.length <= 10) {
        setFormData({ ...formData, [name]: numbersOnly });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const [showPassword, setShowPassword] = useState(false);
  const handlePassChange = (e) => {
    setPassData({ ...passData, [e.target.name]: e.target.value });
  };

  const handleInfoSubmit = (e) => {
    e.preventDefault();
    let tempErrors = {};

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(formData.email)) {
      tempErrors.email = "Invalid email format";
    }

    if (formData.role === "CUSTOMER" && !formData?.account?.id) {
      tempErrors.account = "Account is required for Customer role";
    }

    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobileRegex.test(formData.mobileNumber)) {
      tempErrors.mobileNumber = "Must be 10 digits starting with 6-9";
    }

    if (!formData.fullName.trim()) {
      tempErrors.fullName = "Name is required";
    }

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length === 0) {
      const payload =
  formData.role === "CUSTOMER"
    ? {
        ...formData,
        account: {
          id: formData?.account?.id || "",
        },
      }
    : formData;
onSave(payload);

    }
  };
  return (
    <div className="space-y-2 bg-white rounded-lg shadow-sm border border-gray-200 p-3 w-3/4 md:w-3/5">
      <form onSubmit={handleInfoSubmit} className="space-y-2">
        <div className="border-b pb-0.5 flex flex-row items-center justify-between">
          <h3 className="text-lg font-bold text-gray-900">
            {isReadOnly
              ? "View Profile"
              : employee
                ? "Edit Profile Information"
                : "Add New Employee"}
          </h3>
          <button
            onClick={onCancel}
            type="button"
            className="p-1 text-red-600 bg-red-50 hover:bg-red-100"
          >
            <X />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-0">
              Full Name <span className="text-red-500">*</span>
            </label>
            <input
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              disabled={isReadOnly}
              className={`w-full border rounded-md py-1 px-3 focus:outline-none focus:ring-1 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 focus:border-blue-500 disabled:bg-gray-50 ${errors.email ? "border-red-500" : "border-gray-300"}`}
              required
            />
            {errors.fullName && (
              <p className="text-red-500 text-xs mt-1">{errors.fullName}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-0">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              disabled={isReadOnly}
              className={`w-full border rounded-md py-1 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 ${errors.email ? "border-red-500" : "border-gray-300"}`}
              required
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1">{errors.email}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-0">
              Phone Number <span className="text-red-500">*</span>
            </label>
            <input
              name="mobileNumber"
              value={formData.mobileNumber}
              maxLength={10}
              onChange={handleChange}
              disabled={isReadOnly}
              className={`w-full border rounded-md py-1 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 ${errors.email ? "border-red-500" : "border-gray-300"}`}
              required
            />
            {errors.mobileNumber && (
              <p className="text-red-500 text-xs mt-1">{errors.mobileNumber}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-0">
              Role <span className="text-red-500">*</span>
            </label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              disabled={isReadOnly || formData.role === "ADMIN" ? true : false}
              className="w-full border border-gray-300 rounded-md py-1 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50"
            >
              {/* <option value="ADMIN">ADMIN</option> */}
              <option value="CUSTOMER">CUSTOMER</option>
              <option value="USER">USER</option>
            </select>
          </div>

          {formData.role === "CUSTOMER" && (
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 mb-0">
                Account <span className="text-red-500">*</span>
              </label>

              {selectedAccount ? (
                <div className="flex items-center justify-between border rounded-md px-3 py-1 bg-gray-50">
                  <span>{selectedAccount.accountName}</span>

                  <button
                    type="button"
                    onClick={() => {
                      setSelectedAccount(null);
                      setFormData((prev) => ({
                        ...prev,
                        account: { id: "" },
                      }));

                      setAccountQuery("");
                    }}
                  >
                    {!isReadOnly && <X size={16} />}
                  </button>
                </div>
              ) : (
                <>
                  <input
                    value={accountQuery}
                    onChange={(e) => setAccountQuery(e.target.value)}
                    placeholder="Search account (min 4 chars)"
                    className="w-full border border-gray-300 rounded-md py-1 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 px-3"
                    disabled={isReadOnly}
                  />
                  {errors.account && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.account}
                    </p>
                  )}

                  {accountQuery.length >= 3 && !loadingAccounts && (
                    <div className="absolute z-50 bg-white border rounded-md shadow w-full max-h-48 overflow-auto mt-1">
                      {/* Accounts found */}
                      {accounts.length > 0 ? (
                        accounts.map((acc) => (
                          <div
                            key={acc.id}
                            onClick={() => {
                              setSelectedAccount(acc);
                              setFormData((prev) => ({
                                ...prev,
                                account: { id: acc.id },
                              }));
                              setAccounts([]);
                              setAccountQuery("");
                            }}
                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                          >
                            {acc.accountName}
                          </div>
                        ))
                      ) : (
                        /* No result */
                        <div className="px-3 py-2 text-sm text-gray-500 text-center">
                          No accounts found
                        </div>
                      )}
                    </div>
                  )}

                  {loadingAccounts && (
                    <p className="text-xs text-gray-400 mt-1">Searching...</p>
                  )}
                </>
              )}
            </div>
          )}

          {!employee && !isReadOnly && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-0">
                Initial Password <span className="text-red-500">*</span>
              </label>
              {/* <input
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md py-1 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                required
              /> */}
              <div className="relative">
                <input
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  className="w-full border focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md py-1 px-3 pr-10"
                />

                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-end space-x-3 pt-1">
          {!isReadOnly && (
            <button
              type="submit"
              className="bg-primary py-2 px-4 border border-transparent rounded-md text-sm font-medium text-white hover:bg-blue-700"
            >
              {employee ? "Update Info" : "Create User"}
            </button>
          )}
        </div>
      </form>

      {employee && !isReadOnly && (
        <div className="bg-gray-50 p-2 rounded-lg border border-gray-200">
          <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
            <span className="bg-yellow-400 h-2 w-2 rounded-full mr-2"></span>
            Change Password
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-2">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-0">
                New Password
              </label>

              <div className="relative">
                <input
                  name="newPassword"
                  type={showPassword ? "text" : "password"}
                  value={passData.newPassword}
                  onChange={handlePassChange}
                  placeholder="••••••••"
                  className="w-full border focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md py-1 px-3 pr-10"
                />

                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
          </div>
          <div className="flex items-end justify-end">
            <button
              type="button"
              onClick={() => {
                if (!passData.newPassword) {
                  alert("Please fill both password fields");
                  return;
                }
                onUpdatePassword(passData);
              }}
              className="bg-primary py-2 px-4 border border-transparent rounded-md text-sm font-medium text-white hover:bg-blue-700"
            >
              Change Password
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
